export default __webpack_public_path__ + "static/media/pwc-logo-dark.73b3f8f1.svg";